module.exports = __webpack_public_path__ + "img/world-energy-trends-cover-2024.af26c7a.jpg";